import OrderedList from '@tiptap/extension-ordered-list';

export const ContentOrdererdList = OrderedList.extend({
  draggable: true,
});
